import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "m9.55 12 7.35 7.35q.374.375.363.875a1.25 1.25 0 0 1-.388.875 1.2 1.2 0 0 1-.875.375 1.2 1.2 0 0 1-.875-.375l-7.7-7.675q-.3-.3-.45-.675t-.15-.75c0-.375.05-.5.15-.75q.15-.375.45-.675l7.7-7.7q.375-.375.887-.362.513.012.888.387c.375.375.375.542.375.875a1.2 1.2 0 0 1-.375.875z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }